module.exports = __webpack_public_path__ + "static/img/liandong.0ee7e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/liandong.png
// module id = 3UEu
// module chunks = 24